import React from 'react';
import { MapPin, Phone, Clock, Navigation, ExternalLink } from 'lucide-react';
import { useSettings } from '../hooks/useSettings';

const LocationSection = () => {
  const settings = useSettings();
  const whatsappLink = `https://wa.me/6${settings.whatsappNumber}`;
  const googleMapsLink = 'https://maps.google.com/?q=1.956800,102.858704';
  const googleMapsEmbed = 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3988.2!2d102.858704!3d1.956800!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMcKwNTcnMjQuNSJOIDEwMsKwNTEnMzEuMyJF!5e0!3m2!1sen!2smy!4v1';
  
  return (
    <section id="lokasi" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            Lokasi Gudang
          </h2>
          <p className="text-sm text-gray-600 max-w-xl mx-auto">
            Datang terus ke gudang untuk lihat dan alami sendiri kualiti perabot jati dari Jepara
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-stretch">
          {/* Google Maps Embed */}
          <div className="rounded-xl overflow-hidden shadow-lg border border-gray-100 min-h-[350px]">
            <iframe
              src={googleMapsEmbed}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '350px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Lokasi Gudang Boss Ijan"
            ></iframe>
          </div>

          {/* Info Card */}
          <div className="space-y-4">
            {/* Contact Info */}
            <div className="bg-gray-50 rounded-xl p-5">
              <h3 className="font-semibold text-gray-900 mb-4">Maklumat Gudang</h3>
              
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-4 h-4 text-amber-700" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Johor, Malaysia</p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="w-4 h-4 text-green-700" />
                  </div>
                  <div>
                    <a 
                      href={whatsappLink}
                      className="text-sm text-green-600 font-medium hover:underline"
                    >
                      {settings.whatsappNumber}
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="w-4 h-4 text-blue-700" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Setiap Hari: 9:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>

              {/* Open in Google Maps Button */}
              <a
                href={googleMapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center justify-center gap-2 w-full bg-white border border-gray-200 text-gray-700 px-4 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"
                data-testid="open-maps-btn"
              >
                <Navigation className="w-4 h-4" />
                Buka di Google Maps
                <ExternalLink className="w-3 h-3" />
              </a>
            </div>

            {/* CTA Card */}
            <div className="bg-gradient-to-br from-amber-600 to-amber-700 text-white rounded-xl p-5">
              <h3 className="font-semibold mb-2">Stok Cepat Jalan!</h3>
              <p className="text-sm text-amber-100 mb-4">
                Ramai pelanggan datang terus angkut 2-3 set. Tanya sebelum stok habis.
              </p>
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white text-amber-700 px-5 py-2.5 rounded-lg font-medium text-sm hover:bg-amber-50 transition-colors w-full"
                data-testid="location-whatsapp-btn"
              >
                <Phone size={16} />
                WhatsApp Sekarang
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
